let ctx;
const getCtx = () => {
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  return ctx;
};

// One "note": fundamental + a quiet upper harmonic (fifth/octave) through a gentle lowpass,
// which is what makes a synthesized tone read as a smooth modern chime instead of a flat,
// harsh chiptune beep — every sound below is built from these, sine/triangle only (no raw
// square/sawtooth), so nothing here sounds "jadul".
function note(c, { freq, start, dur, type = "sine", gain = 0.16, harmonic = 2, harmonicGain = 0.35 }) {
  const filter = c.createBiquadFilter();
  filter.type = "lowpass";
  filter.frequency.value = 5200;
  filter.connect(c.destination);

  const layer = (f, g, t) => {
    const osc = c.createOscillator();
    const amp = c.createGain();
    osc.type = t;
    osc.frequency.value = f;
    amp.gain.setValueAtTime(0, start);
    amp.gain.linearRampToValueAtTime(g, start + 0.012);
    amp.gain.exponentialRampToValueAtTime(0.0008, start + dur);
    osc.connect(amp).connect(filter);
    osc.start(start);
    osc.stop(start + dur + 0.02);
  };
  layer(freq, gain, type);
  if (harmonicGain > 0) layer(freq * harmonic, gain * harmonicGain, type);
}

// Every entry is a self-contained Web Audio "instrument" — no bundled audio files (keeps
// the app self-contained), tuned to read as a modern, bright notification tone rather than
// a retro beep. Real OS-default tones (iOS "Tri-tone", "Glass", etc.) are Apple's own
// copyrighted assets and can't be bundled or reproduced — these are original tones in a
// similar spirit (short, bright, pleasant), not copies of any specific device's sounds.
export const NOTIF_SOUNDS = [
  { id: "chime", label: "Chime Naik", play: (c, t) => { note(c, { freq: 880, start: t, dur: 0.24 }); note(c, { freq: 1318, start: t + 0.09, dur: 0.3 }); } },
  { id: "chime_down", label: "Chime Turun", play: (c, t) => { note(c, { freq: 1318, start: t, dur: 0.22 }); note(c, { freq: 880, start: t + 0.08, dur: 0.3 }); } },
  { id: "glass", label: "Glass", play: (c, t) => { note(c, { freq: 1568, start: t, dur: 0.3, gain: 0.14, harmonic: 2.01, harmonicGain: 0.4 }); note(c, { freq: 2093, start: t + 0.05, dur: 0.35, gain: 0.09, harmonic: 1.5, harmonicGain: 0.3 }); } },
  { id: "bell", label: "Lonceng", play: (c, t) => { note(c, { freq: 1046, start: t, dur: 0.6, type: "triangle", gain: 0.13, harmonic: 2.4, harmonicGain: 0.25 }); } },
  { id: "tri", label: "Tri-Chime", play: (c, t) => { note(c, { freq: 784, start: t, dur: 0.18, gain: 0.14 }); note(c, { freq: 988, start: t + 0.1, dur: 0.18, gain: 0.14 }); note(c, { freq: 1318, start: t + 0.2, dur: 0.3, gain: 0.14 }); } },
  { id: "reflect", label: "Reflect", play: (c, t) => { note(c, { freq: 1568, start: t, dur: 0.2, gain: 0.13 }); note(c, { freq: 1174, start: t + 0.11, dur: 0.22, gain: 0.12 }); note(c, { freq: 880, start: t + 0.22, dur: 0.3, gain: 0.11 }); } },
  { id: "marimba", label: "Marimba", play: (c, t) => { note(c, { freq: 523, start: t, dur: 0.28, type: "triangle" }); note(c, { freq: 659, start: t + 0.09, dur: 0.28, type: "triangle" }); note(c, { freq: 784, start: t + 0.18, dur: 0.32, type: "triangle" }); } },
  { id: "xylophone", label: "Xylophone", play: (c, t) => { note(c, { freq: 1046, start: t, dur: 0.18, type: "triangle", gain: 0.15 }); note(c, { freq: 1244, start: t + 0.06, dur: 0.18, type: "triangle", gain: 0.15 }); note(c, { freq: 1568, start: t + 0.12, dur: 0.24, type: "triangle", gain: 0.15 }); } },
  { id: "note_single", label: "Note", play: (c, t) => { note(c, { freq: 987, start: t, dur: 0.4, gain: 0.16, harmonic: 2, harmonicGain: 0.3 }); } },
  { id: "digital", label: "Digital Ceria", play: (c, t) => { note(c, { freq: 1568, start: t, dur: 0.08, gain: 0.13 }); note(c, { freq: 1976, start: t + 0.09, dur: 0.08, gain: 0.13 }); note(c, { freq: 2349, start: t + 0.18, dur: 0.14, gain: 0.13 }); } },
  { id: "sonar", label: "Sonar", play: (c, t) => { note(c, { freq: 1200, start: t, dur: 0.5, gain: 0.12, harmonic: 2, harmonicGain: 0.15 }); } },
  { id: "soft", label: "Lembut", play: (c, t) => { note(c, { freq: 660, start: t, dur: 0.45, gain: 0.12, harmonicGain: 0.15 }); } },
  { id: "anggun", label: "Anggun", play: (c, t) => { note(c, { freq: 659, start: t, dur: 0.35, gain: 0.11 }); note(c, { freq: 830, start: t + 0.02, dur: 0.35, gain: 0.1 }); note(c, { freq: 987, start: t + 0.04, dur: 0.4, gain: 0.09 }); } },
  { id: "ping_ganda", label: "Ping Ganda", play: (c, t) => { note(c, { freq: 1500, start: t, dur: 0.13, gain: 0.14 }); note(c, { freq: 1500, start: t + 0.16, dur: 0.13, gain: 0.14 }); } },
  { id: "tegas", label: "Tegas", play: (c, t) => { note(c, { freq: 587, start: t, dur: 0.16, type: "triangle", gain: 0.17, harmonicGain: 0.2 }); note(c, { freq: 587, start: t + 0.2, dur: 0.16, type: "triangle", gain: 0.17, harmonicGain: 0.2 }); } },
  { id: "pop", label: "Pop", play: (c, t) => { note(c, { freq: 320, start: t, dur: 0.07, gain: 0.18, harmonicGain: 0 }); note(c, { freq: 1100, start: t + 0.015, dur: 0.09, gain: 0.09, harmonicGain: 0 }); } },
  { id: "ding", label: "Ding", play: (c, t) => { note(c, { freq: 1760, start: t, dur: 0.5, gain: 0.12, harmonic: 2, harmonicGain: 0.2 }); } },
  { id: "klasik", label: "Klasik", play: (c, t) => { note(c, { freq: 988, start: t, dur: 0.16, gain: 0.14 }); note(c, { freq: 1318, start: t + 0.12, dur: 0.3, gain: 0.14 }); } },
];

export function playNotifSound(soundId = "anggun") {
  try {
    const c = getCtx();
    const run = () => {
      const entry = NOTIF_SOUNDS.find((s) => s.id === soundId) || NOTIF_SOUNDS[0];
      entry.play(c, c.currentTime);
    };
    if (c.state === "suspended") { c.resume().then(run); return; }
    run();
  } catch { /* audio not available */ }
}

// Android Chrome supports the Vibration API for any website/PWA. iOS Safari — including
// a web app installed to the Home Screen — has never implemented navigator.vibrate at all;
// this is a WebKit platform limitation with no JS workaround, not something this app can
// fix from the web (only a native/wrapped app with real device APIs could do haptics on
// iPhone). Silently no-ops there rather than erroring.
export const vibrationSupported = typeof navigator !== "undefined" && "vibrate" in navigator;

export function vibrateDevice() {
  try { if (navigator.vibrate) navigator.vibrate([120, 60, 120]); } catch { /* unsupported */ }
}

export function requestNotifPermission() {
  if (typeof Notification === "undefined") return;
  if (Notification.permission === "default") Notification.requestPermission();
}

export function showBrowserNotification(title, body) {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
  if (document.visibilityState === "visible") return;
  try { new Notification(title, { body, icon: "/favicon.ico" }); } catch { /* noop */ }
}
